<template>
    <v-app>
        <v-container fluid>
            <v-row v-if="$insertAccess($route.path)">
                <v-col md="3" cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                                color="blue-grey-lighten-4"
                                class="panel-header"
                                >Others Info</v-expansion-panel-title
                            >
                            <v-expansion-panel-text>
                                <v-form
                                @submit.prevent="submitForm(currentStatus)"
                                ref="addPurOrder"
                                id="addPurOrder"
                                >
                                    <v-row class="pa-2">
                                        <v-col cols="12">
                                            <v-autocomplete
                                                label="Purchase Order"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="pur_order_master_id.value.value"
                                                :items="filteredPurRequisitionList"
                                                :item-title="(item) => `${item.code}`"
                                                item-value="id"
                                                @update:modelValue="onRequisitionChange"
                                                :error-messages="pur_order_master_id.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template #label>
                                                    Purchase Order
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>

                                            <v-autocomplete
                                                label="Warehouse"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="warehouse_id.value.value"
                                                :items="getWarehouseList"
                                                :item-title="(item) => `${item.name}`"
                                                item-value="id"
                                                :error-messages="warehouse_id.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template #label>
                                                    Warehouse
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>

                                            
                                            <v-autocomplete
                                                label="Purpose"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="purpose_id.value.value"
                                                :items="getPurposeList"
                                                :item-title="(item) => `${item.name}`"
                                                item-value="id"
                                                :error-messages="purpose_id.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template #label>
                                                    Purpose
                                                    <span class="text-red-accent-4"></span>
                                                </template>
                                            </v-autocomplete>

                                            <v-autocomplete
                                                label="Supplier Name"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="supplier_id.value.value"
                                                :items="getSupplierList"
                                                :item-title="(item) => `${item.name}`"
                                                item-value="id"
                                                :error-messages="supplier_id.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template #label>
                                                    Supplier Name
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>

                                            <v-date-input
                                                input-format="dd/mm/yyyy"
                                                label="Receive Date"
                                                density="compact"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi-calendar"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="receive_date.value.value"
                                                :error-messages="receive_date.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-date-input>

                                            <v-date-input
                                                input-format="dd/mm/yyyy"
                                                label="Shipping Date"
                                                density="compact"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi-calendar"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="shipping_date.value.value"
                                                :error-messages="shipping_date.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-date-input>

                                            <v-date-input
                                                input-format="dd/mm/yyyy"
                                                label="Purchase Date"
                                                density="compact"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi-calendar"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="purchase_date.value.value"
                                                :error-messages="purchase_date.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-date-input>

                                            <v-autocomplete
                                                label="Purchase Type"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="purchase_type.value.value"
                                                :items="types"
                                                :item-title="(item) => `${item.name}`"
                                                item-value="id"
                                                :error-messages="purchase_type.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template #label>
                                                    Purchase Type
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>

                                            <v-textarea
                                                label="Shipping Address"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="shipping_address.value.value"
                                                :error-messages="shipping_address.errorMessage.value"
                                                autocomplete="off"
                                                rows="1"
                                                clearable
                                            ></v-textarea>

                                            <v-text-field
                                                label="Rfq By"
                                                density="compact"
                                                single-line
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="purOrder_by.value.value"
                                                :error-messages="purOrder_by.errorMessage.value"
                                                autocomplete="off"
                                                :disabled="true"
                                                clearable
                                            ></v-text-field>

                                            <v-text-field
                                                label="Rfq By Mobile"
                                                density="compact"
                                                single-line
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="purOrder_by_mobile.value.value"
                                                :error-messages="purOrder_by.errorMessage.value"
                                                autocomplete="off"
                                                :disabled="true"
                                                clearable
                                            ></v-text-field>

                                            <v-text-field
                                                label="Rfq By Email"
                                                density="compact"
                                                single-line
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="purOrder_by_email.value.value"
                                                :error-messages="purOrder_by_email.errorMessage.value"
                                                :disabled="true"
                                                autocomplete="off"
                                                clearable
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>

                <v-col md="9" cols="12">
                    <v-expansion-panels v-model="panel2">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                                color="blue-grey-lighten-4"
                                class="panel-header"
                                >Item Info</v-expansion-panel-title
                            >
                            <v-expansion-panel-text>
                                <v-form
                                @submit.prevent="submitForm(currentStatus)"
                                ref="addPurOrder"
                                id="addPurOrder"
                                >
                                    <v-row class="pt-2 justify-center">
                                        <v-col cols="8">
                                            <v-autocomplete
                                                label="Search Product Name"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="product_id.value.value"
                                                :items="getProductMapList"
                                                :item-title="(item) => `${item.product.code}-${item.product.name}` ?? 'N/A'"
                                                item-value="product_id"
                                                :error-messages="product_id.errorMessage.value"
                                                autocomplete="off"
                                                @update:model-value="addCart"
                                                @keydown.enter="addCart"
                                                clearable
                                            ></v-autocomplete>

                                            <input
                                                v-model="pur_order_master_id.value.value"
                                                type="hidden"
                                            />
                                        </v-col>

                                        <!-- <v-col cols="1">
                                            <v-btn class="bg-primary" @click="addCart">ADD</v-btn>
                                        </v-col> -->
                                    </v-row>

                                    <!-- Cart Table -->
                                    <v-row class="pt-0">
                                        <v-col cols="12">
                                        <!-- <v-table density="compact" :loading="loading" fixed-header class="table-dotted-border-bottom" style="height:40vh; overflow-y: scroll;"> -->
                                            <v-table
                                                density="compact"
                                                :loading="loading"
                                                fixed-header
                                                class="table-dotted-border-bottom"
                                                style="height: 40vh; overflow-y: scroll"
                                            >
                                                <thead>
                                                    <tr>
                                                        <th class="text-center" style="width: 5%">SL</th>
                                                        <th class="text-left" style="width: 25%">
                                                        Product Name
                                                        </th>
                                                        <th class="text-center" style="width: 15%">
                                                        Quantity
                                                        </th>
                                                        <th class="text-center" style="width: 15%">Unit</th>
                                                        <th class="text-right" style="width: 15%;display:none">Rate</th>
                                                        <th class="text-right" style="width: 15%;display:none" >
                                                        Sub Total
                                                        </th>
                                                        <th class="text-center" style="width: 10%">
                                                        Action
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                        v-for="(item, index) in cart"
                                                        v-if="cart.length > 0"
                                                        :key="index"
                                                    >
                                                        <td class="text-center py-1">{{ index + 1 }}</td>
                                                        <td
                                                        class="text-left py-1"
                                                        style="white-space: normal"
                                                        >
                                                        {{ item.product_name }}
                                                        </td>
                                                        <td class="text-right py-1">
                                                        <v-text-field
                                                            :reverse="false"
                                                            controlVariant="stacked"
                                                            label=""
                                                            :hideInput="false"
                                                            :inset="false"
                                                            :min="1"
                                                            type="number"
                                                            style="width: 80px"
                                                            density="compact"
                                                            variant="outlined"
                                                            bg-color="grey-lighten-4"
                                                            v-model="item.qty"
                                                            :error-messages="
                                                            item.qty < 1
                                                                ? 'Quantity must be greater than 0'
                                                                : ''
                                                            "
                                                            @update:model-value="
                                                            item.total = item.qty * item.rate
                                                            "
                                                            @blur="item.total = item.qty * item.rate"
                                                        ></v-text-field>
                                                        </td>
                                                        <td class="text-center py-1">
                                                        {{ item.unit_name }}
                                                        </td>
                                                        <td class="text-right py-1" style="display:none">
                                                           <v-text-field
                                                              :reverse="false"
                                                              controlVariant="stacked"
                                                              style="width:100px;"
                                                              label=""
                                                              :hideInput="false"
                                                              :inset="false"
                                                              :min="1"
                                                              type="number"
                                                              density="compact"
                                                              variant="outlined"
                                                              bg-color="grey-lighten-4"
                                                              v-model="item.rate"
                                                              hide-details
                                                              :error="item.rate < 1"
                                                              :error-messages=" item.qty < 1 ? 'rate must be greater than 0' : '' "
                                                              @update:model-value=" item.total = item.qty * item.rate "
                                                            ></v-text-field>
                                                        </td>
                                                        <td class="text-right py-1" style="display:none">
                                                        {{ this.$numberFormat(item.total) }}
                                                        </td>
                                                        <td class="text-center py-1">
                                                        <v-icon
                                                            size="small"
                                                            color="red"
                                                            class="delete-button"
                                                            @click="removeFromCart(index)"
                                                        >
                                                            mdi-delete
                                                        </v-icon>
                                                        </td>
                                                    </tr>

                                                    <tr v-else-if="loading == true">
                                                        <td colspan="6" class="text-center">
                                                        <v-skeleton-loader
                                                            type="heading"
                                                            :loading="loading"
                                                        />
                                                        </td>
                                                    </tr>
                                                    <tr v-else>
                                                        <td colspan="6" class="text-center text-red">
                                                        You have no item
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </v-table>
                                        </v-col>
                                    </v-row>
                                    <!-- Close Cart Table -->

                                    <v-divider></v-divider>
                                    <v-card-actions>
                                        <v-row class="pt-2">
                                        <v-col cols="8">
                                            <v-textarea
                                            label="Description"
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="remarks.value.value"
                                            :error-messages="remarks.errorMessage.value"
                                            autocomplete="off"
                                            rows="3"
                                            clearable
                                            ></v-textarea>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-layout class="justify-end">
                                              <v-btn
                                                  class="bg-grey-darken-1 me-2"
                                                  variant="flat"
                                                  @click="submitForm(0)"
                                                  >DRAFT</v-btn
                                              >
                                              <v-btn
                                                  class="bg-primary"
                                                  variant="flat"
                                                  @click="submitForm(1)"
                                                  >POST</v-btn
                                              >
                                            </v-layout>
                                        </v-col>
                                        </v-row>
                                    </v-card-actions>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { nextTick, ref } from "vue";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";
import { useRouter } from "vue-router";
export default {
  components: {},
  data: () => ({
    panel: [0],
    panel2: [0],
    loading: false,
    errorMessages: "",
    visible: false,
    search: "",
    selectedImage: null,
    photo_imageFile: "",
    preview: "/src/assets/no_preview.png",
    cart: [],
    types: [
      { id: 1, name: "Normal" },
      { id: 2, name: "Urgent" },
    ],
  }),
  watch: {},
  created() {
    if (this.$store.getters.getWarehouseList.length === 0) {
      this.$store.dispatch("getWarehouseList");
    }
    if (this.$store.getters.getPurposeList.length === 0) {
      this.$store.dispatch("getPurposeList");
    }
    if (this.$store.getters.getSupplierList.length === 0) {
      this.$store.dispatch("getSupplierList");
    }
    if (this.$store.getters.getProductMapList.length === 0) {
      this.$store.dispatch("getProductMapList");
    }

    //if (this.$store.getters.getReceivablePurchaseOrderList.length === 0) {
      this.$store.dispatch("getReceivablePurchaseOrderList");
    //}
  },
  computed: {
    branchId() {
      return this.$store.getters.getAuthUser.branch_id || null;
    },
    getWarehouseList() {
      return this.$store.getters.getWarehouseList;
    },
    getPurposeList() {
      return this.$store.getters.getPurposeList;
    },
    getProductMapList() {
      let products = this.$store.getters.getProductMapList;
      return products.filter(
        (item) => item.branch_id == this.branchId && item.status == 1
      );
    },
    getSupplierList() {
      return this.$store.getters.getSupplierList;
    },
    filteredPurRequisitionList() {
      const requisitions = this.$store.getters.getReceivablePurchaseOrderList || [];
      return requisitions.filter(
        (item) => item.branch_id == this.branchId && item.status == 1
      );
    },
  },
  methods: {
    addCart() {
      let cartInd = this.cart.findIndex(
        (p) => p.product_id == this.product_id.value.value
      );
      if (this.product_id.value.value == null) {
        toast.error("Please select a Product");
        this.cartReset();
        return false;
      }
      if (cartInd > -1) {
        toast.error("Product already added in cart");
        this.cartReset();
        return false;
      }

      let product = this.getProductMapList.find(
        (item) => item.id == this.product_id.value.value
      );
      product = product.product;

      let item = {
        product_id: this.product_id.value.value,
        product_name: product.name,
        qty: 1,
        unit_id: product.unit_id,
        unit_name: product.unit.name,
        rate: product.purchase_rate,
        total: product.purchase_rate,
      };

      this.cart.push(item);
      this.$nextTick(() => {
        this.cartReset();
      });
    },
    removeFromCart(index) {
      if (confirm("Are You Sure?")) {
        this.cart.splice(index, 1);
      }
    },
    cartReset() {
      this.product_id.value.value = null;
    },
    async onRequisitionChange(selectedId) {
      if (!selectedId) {
        this.warehouse_id.value.value = null;
        this.purpose_id.value.value = null;
        this.type_id.value.value = null;
        this.shipping_address.value.value = "";
        this.cart = [];
        return;
      }

      try {
        this.$store.commit("SET_LOADING", { color: "primary" });
        const data = await this.$store.dispatch(
          "getPurOrderById",
          selectedId
        );

        this.warehouse_id.value.value =
          data.warehouse_id || data.warehouse?.id || null;
        this.purpose_id.value.value = data.purpose_id || null;
        this.supplier_id.value.value =
          data.supplier_id || data.supplier?.id || null;
        this.purchase_type.value.value = data.purchase_type
          ? parseInt(data.purchase_type)
          : null;
        this.purchase_date.value.value = data.purchase_date
          ? new Date(data.purchase_date)
          : null;
        this.shipping_date.value.value = data.shipping_date
          ? new Date(data.shipping_date)
          : null;
        this.shipping_address.value.value =
          data.shipping_address ||
          data.warehouse?.address ||
          data.supplier?.address ||
          "";
        this.remarks.value.value = data.remarks || "";
        this.po_master_id.value.value = data.id || null;

        this.cart = [];
        const orderDetails =
          data.pur_order_details || data.purOrderDetails || [];
        orderDetails.forEach((item) => {
          this.cart.push({
            product_id: item.product_id,
            product_name: item.product?.name || "",
            qty: item.qty,
            unit_id: item.product?.unit_id || item.product?.unit?.id || "",
            unit_name: item.product?.unit?.name || "",
            rate: item.rate,
            total: item.qty * item.rate,
          });
        });
        this.$store.commit("UNSET_LOADING");
      } catch (error) {
        console.error("Failed to load requisition data:", error);
      }
    },
  },
  setup() {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        purchase_date: yup.date().required().label("Purchase Date"),
        receive_date: yup.date().required().label("Receive Date"),
        shipping_date: yup.date().nullable().label("Shipping Date"),
        warehouse_id: yup.number().positive().integer().required().label("Designation Name"),
        pur_order_master_id: yup.number().positive().integer().required().label("Purchase Order"),
        supplier_id: yup.number().positive().integer().required().label("Supplier Name"),
        shipping_address: yup.string().required().label("shipping Address"),
        purchase_type: yup.string().required().label("purchase_type"),
      }),
    });
    
    const inv_po_receive_masters_id = useField("inv_po_receive_masters_id");
    const shipping_address = useField("shipping_address");
    const shipping_date = useField("shipping_date");
    const receive_date = useField("receive_date");
    const product_id = useField("product_id");
    const purchase_type = useField("purchase_type");
    const pr_status = useField("pr_status");
    const employee_id = useField("employee_id");
    const warehouse_id = useField("warehouse_id");
    const purpose_id = useField("purpose_id");
    const po_master_id = useField("po_master_id");
    const supplier_id = useField("supplier_id");
    const pur_order_master_id = useField("pur_order_master_id");
    const purchase_date = useField("purchase_date");
    const remarks = useField("remarks");
    const purOrder_by = useField("purOrder_by");
    const purOrder_by_mobile = useField("purOrder_by_mobile");
    const purOrder_by_email = useField("purOrder_by_email");
    const errorMessages = ref("");
    const cart = ref([]);
    const loading = ref("");
    const buttonText = ref("");
    buttonText.value = "Save";
    const store = useStore();
    const router = useRouter();

    const currentStatus = ref(0);

    const submitForm = (status) => {
      currentStatus.value = status;
      submit();
    };

    const submit = handleSubmit((values) => {
      console.log(values);
      values.status = currentStatus.value;
      values.cart = cart.value;
      values.purchase_date = formattedDate(purchase_date.value.value);

      store
        .dispatch("saveUpdateInvPoReceive", values)
        .then((response) => {
          resetForm();
          buttonText.value = "Save";
          cart.value = [];
          toast.success(response.data.message, {
            timeout: 3000,
          });
          setTimeout(() => {
            router.push({ name: "po-receive-records" });
          }, 2000);
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        });
    });

    return {
      submitForm,
      submit,
      inv_po_receive_masters_id,
      product_id,
      purchase_date,
      remarks,
      purchase_type,
      cart,
      purOrder_by,
      purOrder_by_mobile,
      purOrder_by_email,
      pr_status,
      errorMessages,
      employee_id,
      warehouse_id,
      purpose_id,
      po_master_id,
      supplier_id,
      pur_order_master_id,
      buttonText,
      loading,
      shipping_date,
      receive_date,
      shipping_address,
    };
  },

  mounted() {
    this.pr_status.value.value = "1";
    this.employee_id.value.value = "";
    let user = this.$store.getters.getAuthUser;
    this.purOrder_by.value.value = user.full_name;
    this.purOrder_by_mobile.value.value = user.mobile;
    this.purOrder_by_email.value.value = user.email;

    const id = this.$route.query.id;
    if (id) {
      this.$store.commit("SET_LOADING", { color: "primary" });

      this.$nextTick(() => {
        this.$store
          .dispatch("getInvPoReceiveById", id)
          .then((data) => {
            this.isEntryMode = false;
            let purOrder = data;
            console.log(purOrder);
            this.inv_po_receive_masters_id.value.value = purOrder.id;
            this.pur_order_master_id.value.value = purOrder.pur_order_master_id;
            this.purchase_date.value.value = purOrder.purchase_date
              ? new Date(purOrder.purchase_date)
              : new Date();
            this.receive_date.value.value = purOrder.receive_date
              ? new Date(purOrder.receive_date)
              : new Date();
            this.shipping_date.value.value = purOrder.shipping_date
              ? new Date(purOrder.shipping_date)
              : new Date();
            this.purchase_type.value.value = parseInt(purOrder.purchase_type);
            this.warehouse_id.value.value = purOrder.warehouse.id;
            this.purpose_id.value.value = purOrder.purpose_id;
            this.shipping_address.value.value = purOrder.shipping_address;
            this.product_id.value.value = null;
            this.supplier_id.value.value = purOrder.supplier_id;
            this.cart.value = [];

            // Insert items one by one
            (purOrder.inv_po_receive_details || []).forEach((item) => {
              this.cart.push({
                product_id: item.product_id,
                product_name: item.product?.name || "",
                qty: item.qty,
                unit_id: item.product.unit?.id || "",
                unit_name: item.product.unit?.name || "",
                rate: item.rate,
                total: item.qty * item.rate,
              });
            });
            this.remarks.value.value = purOrder.remarks ? purOrder.remarks : "";
            this.$store.commit("UNSET_LOADING");
          })
          .catch((error) => {
            this.$store.commit("UNSET_LOADING");
            console.error("Failed to fetch rfq:", error);
          });
      });
    } else {
      this.shipping_date.value.value = new Date();
      this.receive_date.value.value = new Date();
      this.purchase_date.value.value = new Date();
      this.isEntryMode = true;
    }
  },
};
</script>
